import React from 'react';
import ActivationTab from './components/ActivationTab';
import ConsoleTab from './components/ConsoleTab';
import ServiceHeader from './components/Header';
import OverviewTab from './components/OverviewTab';
import SettingTab from './components/SettingTab';
import TabNavigation from './components/TabNavigation';
import { useServiceActivationData } from './hooks/useServiceActivationData';

const DetailServiceComponent = ({ service: data, setType }) => {
  const {
    step,
    setStep,
    service,
    form,
    formExpand,
    formExpandAccount,
    license,
    licenseInfo,
    isLoadActiveLicense,
    isLoadActiveLicenseAccount,
    isLoadActiveLicenseNamespace,
    devices,
    devicesActive,
    accounts,
    accountsActive,
    dataNamespace,
    rowSelection,
    rowSelectionAccount,
    keyTable,
    setKeyTable,
    expKeys,
    setExpKeys,
    expKeysAccount,
    setExpKeysAccount,
    initialPerNameSpace,
    initialPerDevice,
    initialPerAccount,
    checkUpdatePerNamespace,
    setCheckUpdatePerNamespace,
    checkUpdatePerDevice,
    setCheckUpdatePerDevice,
    checkUpdatePerAccount,
    setCheckUpdatePerAccount,
    dataPerNameTemp,
    listNotificationService,
    dataSelectNotificationEvent,
    syncLoading,
    activateChain,
    activateChainAccount,
    openApplication,
    onCheckCode,
    onPerDevices,
    onNotificationEvent,
    onSearchDeviceByName,
    onChangeEventNotification,
    onFinishPerNamespace,
    onFinishPerDevice,
    onFinishPerAccount,
    handleTableChange,
    handleTableChangeActive,
    handleTableChangeAccountActive,
    onDeactivateDevice,
    singleActiveDevice,
    onDeactivateAccount,
    singleActiveAccount,
    onDeactivateNameSpace,
    singleActiveNamespace,
    syncActivateDevice,
    syncActivateAccount,
  } = useServiceActivationData({ data, setType });

  return (
    <div className="detail-service-component">
      <ServiceHeader
        service={service}
        setType={setType}
        openApplication={openApplication}
      />

      <TabNavigation
        step={step}
        setStep={setStep}
        service={service}
        onPerDevices={onPerDevices}
        onNotificationEvent={onNotificationEvent}
        onSearchDeviceByName={onSearchDeviceByName}
      />

      {step === 0 && <OverviewTab service={service} />}

      {step === 1 && (
        <ActivationTab
          form={form}
          onCheckCode={onCheckCode}
          license={license}
          licenseInfo={licenseInfo}
          service={service}
          rowSelection={rowSelection}
          rowSelectionAccount={rowSelectionAccount}
          dataNamespace={dataNamespace}
          devices={devices}
          accounts={accounts}
          handleTableChange={handleTableChange}
          isLoadActiveLicenseNamespace={isLoadActiveLicenseNamespace}
          isLoadActiveLicense={isLoadActiveLicense}
          isLoadActiveLicenseAccount={isLoadActiveLicenseAccount}
          onDeactivateNameSpace={onDeactivateNameSpace}
          singleActiveNamespace={singleActiveNamespace}
          onDeactivateDevice={onDeactivateDevice}
          singleActiveDevice={singleActiveDevice}
          onDeactivateAccount={onDeactivateAccount}
          singleActiveAccount={singleActiveAccount}
          syncLoading={syncLoading}
          syncActivateDevice={syncActivateDevice}
          syncActivateAccount={syncActivateAccount}
          activateChain={activateChain}
          activateChainAccount={activateChainAccount}
        />
      )}

      {step === 2 && (
        <SettingTab
          form={form}
          service={service}
          onFinishPerNamespace={onFinishPerNamespace}
          initialPerNameSpace={initialPerNameSpace}
          checkUpdatePerNamespace={checkUpdatePerNamespace}
          setCheckUpdatePerNamespace={setCheckUpdatePerNamespace}
          dataPerNameTemp={dataPerNameTemp}
          listNotificationService={listNotificationService}
          dataSelectNotificationEvent={dataSelectNotificationEvent}
          onChangeEventNotification={onChangeEventNotification}
          keyTable={keyTable}
          devicesActive={devicesActive}
          formExpand={formExpand}
          onFinishPerDevice={onFinishPerDevice}
          initialPerDevice={initialPerDevice}
          checkUpdatePerDevice={checkUpdatePerDevice}
          setCheckUpdatePerDevice={setCheckUpdatePerDevice}
          setKeyTable={setKeyTable}
          expKeys={expKeys}
          setExpKeys={setExpKeys}
          handleTableChangeActive={handleTableChangeActive}
          isLoadActiveLicense={isLoadActiveLicense}
          accountsActive={accountsActive}
          formExpandAccount={formExpandAccount}
          onFinishPerAccount={onFinishPerAccount}
          initialPerAccount={initialPerAccount}
          checkUpdatePerAccount={checkUpdatePerAccount}
          setCheckUpdatePerAccount={setCheckUpdatePerAccount}
          expKeysAccount={expKeysAccount}
          setExpKeysAccount={setExpKeysAccount}
          handleTableChangeAccountActive={handleTableChangeAccountActive}
          isLoadActiveLicenseAccount={isLoadActiveLicenseAccount}
        />
      )}

      {step === 3 && (
        <ConsoleTab
          keyTable={keyTable}
          devicesActive={devicesActive}
          service={service}
          expKeys={expKeys}
          setExpKeys={setExpKeys}
          setKeyTable={setKeyTable}
          setCheckUpdatePerDevice={setCheckUpdatePerDevice}
          formExpand={formExpand}
          initialPerDevice={initialPerDevice}
          handleTableChangeActive={handleTableChangeActive}
          isLoadActiveLicense={isLoadActiveLicense}
        />
      )}
    </div>
  );
};

export default DetailServiceComponent;
